/** Stale past one hour: four missed 15-minute polls — the same window the liveness alert uses. */
export const SYNC_STALE_MINUTES = 60;

export interface SyncAge {
  minutes: number;
  unit: 'now' | 'minutes' | 'hours' | 'days';
  count: number;
}

/**
 * Compact age of a UTC instant, ported from ptc-core's `dataAge`: units are FLOORED, never rounded
 * up (a 90-minute age is "1h", not "2h"); a future time (clock skew) clamps to "just now" rather
 * than a negative age; an unparseable value is null, so the caller says "unavailable" — a malformed
 * value must never read as fresh.
 */
export function syncAge(iso: string, nowMs: number): SyncAge | null {
  const then = new Date(iso).getTime();
  if (Number.isNaN(then)) return null;
  const minutes = Math.max(0, Math.floor((nowMs - then) / 60_000));
  if (minutes < 1) return { minutes, unit: 'now', count: 0 };
  if (minutes < 60) return { minutes, unit: 'minutes', count: minutes };
  const hours = Math.floor(minutes / 60);
  if (hours < 24) return { minutes, unit: 'hours', count: hours };
  return { minutes, unit: 'days', count: Math.floor(hours / 24) };
}
